import script from "./FAQ.vue?vue&type=script&setup=true&lang=ts"
export * from "./FAQ.vue?vue&type=script&setup=true&lang=ts"

import "./FAQ.vue?vue&type=style&index=0&id=4ec9691e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ec9691e"]])

export default __exports__